export default __webpack_public_path__ + "static/media/class_xi_xii.b19eb1a8.png";